export default "__VITE_ASSET__CNrqmlaK__"